<template>
  <Admin style="background: white;">
    <v-main>
      <v-container fluid>
        <report-detail></report-detail>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
  import Admin from '@/components/admin/admin-main-template'
  import ReportDetail from '../../components/admin/report/report-detail'

  export default {
    name: 'Report',
    components: {
      Admin,
      ReportDetail
    }
  }
</script>
